import { Injectable } from "@angular/core";
import { ComponentToastService } from "@shared/services/component-toast/component-toast.service";

@Injectable()
export class CustomerToastService extends ComponentToastService {}